export const Support = {
  Name: "Підтримка",
  Emoji: "💰",
};
